"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.introspectToken = exports.getToken = exports.createAuthorizeURL = exports.getParam = exports.createCodeChallenge = exports.createCodeVerifier = void 0;
const jssha_1 = __importDefault(require("jssha"));
const crypto = __importStar(require("crypto"));
const environment_1 = require("../../utils/environment");
const fetch_1 = require("../common/fetch");
const CODE_VERIFIER_CHARS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-._~';
const GRANT_TYPE = 'authorization_code';
const RSI_HOST = (0, environment_1.byEnvironment)({
    local: 'https://deve.accounts.ricoh.com',
    development: 'https://deve.accounts.ricoh.com',
    staging: 'https://staging.accounts.ricoh.com',
    production: 'https://na.accounts.ricoh.com',
    test: 'https://devu.accounts.ricoh.com',
});
const RSI_API_HOST = (0, environment_1.byEnvironment)({
    local: 'https://api.deve.smart-integration.ricoh.com',
    development: 'https://api.deve.smart-integration.ricoh.com',
    test: 'https://api.devu.smart-integration.ricoh.com',
    staging: 'https://api.staging.smart-integration.ricoh.com',
    production: 'https://api.na.smart-integration.ricoh.com',
});
/**
 * PKCEのためのランダムな文字列 `code_verifier`を生成する
 *
 * #### インポート
 * ```typescript
 * import { createCodeVerifier } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 *
 * @returns code_verifier 半角英数字, 記号(`- . _ ~`)を含む48文字のランダムな文字列
 */
const createCodeVerifier = () => {
    const str = CODE_VERIFIER_CHARS;
    const number = 48;
    const code = Array.from(crypto.randomFillSync(new Uint8Array(number)))
        .map((n) => str[n % str.length])
        .join('');
    return code;
};
exports.createCodeVerifier = createCodeVerifier;
/**
 * 認可コードを要求時に必要となる `code_challenge`を生成する
 *
 * #### インポート
 * ```typescript
 * import { createCodeChallenge } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 * @param codeVerifier PKCEのためのランダムな文字列 `code_verifier`
 * @returns code_challenge
 * @throws `Length Error` 文字列長が48文字ではない
 * @throws `Format Error` code_verifierに使用できない文字が含まれている
 */
const createCodeChallenge = (codeVerifier) => {
    if (codeVerifier.length !== 48) {
        throw new Error('Length Error');
    }
    [...codeVerifier].forEach((c) => {
        if (!CODE_VERIFIER_CHARS.includes(c)) {
            throw new Error('Format Error');
        }
    });
    const shaObj = new jssha_1.default('SHA-256', 'TEXT', { encoding: 'UTF8' });
    shaObj.update(codeVerifier);
    const hashHEX = shaObj.getHash('BYTES');
    const codeChallenge = window.btoa(hashHEX).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return codeChallenge;
};
exports.createCodeChallenge = createCodeChallenge;
/**
 * URLからクエリの値を取得する
 *
 * #### インポート
 * ```typescript
 * import { getParam } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 * @param name クエリのキー
 * @param url URL 指定しない場合は現在のURL(`window.location.href`)が参照される
 * @returns クエリの値。エラー時や対象のクエリの値が取得できなかった場合はnullまたは空文字を返す
 */
const getParam = (name, url) => {
    const target = new URL(url === undefined ? window.location.href : url);
    return target.searchParams.get(name);
};
exports.getParam = getParam;
/**
 * 認可コードを要求用URLを生成する
 *
 * #### インポート
 * ```typescript
 * import { createAuthorizeURL } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 * @param clientId WFアプリのクライアントID
 * @param codeChallenge 生成したcode_challenge
 * @param redirectURI 認可後のリダイレクトURL
 * @param appendScope デフォルト値に加えて追加するスコープ
 *
 * #### デフォルトスコープ
 *
 * - aut:tenant:read
 * - aut:me:read
 * - uiframework:header:read
 * - sem:license:read
 * - wfa:job:admin
 * - wfa:site_setting:admin
 *
 * @returns 認可コードを要求用URL
 */
const createAuthorizeURL = (clientId, codeChallenge, redirectURI, ...appendScope) => {
    const defaultScopes = [
        'aut:tenant:read',
        'aut:me:read',
        'uiframework:header:read',
        'sem:license:read',
        'wfa:job:admin',
        'wfa:site_setting:admin',
    ];
    const scope = defaultScopes.concat(appendScope).join(' ');
    const params = `?client_id=${clientId}` +
        `&code_challenge=${codeChallenge}` +
        '&code_challenge_method=S256' +
        '&response_type=code' +
        `&redirect_uri=${redirectURI}` +
        `&scope=${scope}`;
    return `${RSI_HOST}/v1/aut/oauth/provider/authorize${params}`;
};
exports.createAuthorizeURL = createAuthorizeURL;
/**
 * アクセストークンを取得する
 *
 * #### インポート
 * ```typescript
 * import { getToken } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 * @param redirectURI リダイレクトURL
 * @param code 認可コード
 * @param codeVerifier 認可コード要求時に生成したcode_verifier
 * @param clientId クライアントID
 * @param expiresIn アクセストークンの有効時間(ミリ秒) デフォルト値は3600
 * @param callback エラー時のコールバック関数
 * @returns 認証情報のオブジェクト
 */
const getToken = (redirectURI, code, codeVerifier, clientId, expiresIn, callback) => __awaiter(void 0, void 0, void 0, function* () {
    const expire = expiresIn ? expiresIn : 3600;
    const body = JSON.stringify({
        grant_type: GRANT_TYPE,
        redirect_uri: redirectURI,
        code: code,
        client_id: clientId,
        code_verifier: codeVerifier,
        expires_in: expire,
    });
    const response = yield (0, fetch_1.post)(`${RSI_API_HOST}/v1/aut/oauth/provider/token/`, {
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body,
    }, callback);
    return response;
});
exports.getToken = getToken;
/**
 * アクセストークンを検証する
 *
 * #### インポート
 * ```typescript
 * import { introspectToken } from 'rj_frontend_common/dist/api/aut/authorize'
 * ```
 * @param token アクセストークン
 * @param clientId クライアントID
 * @param callback エラー時のコールバック関数
 * @returns 有効=true, 無効または検証エラー=false
 */
const introspectToken = (token, clientId, callback) => __awaiter(void 0, void 0, void 0, function* () {
    if (token === null) {
        return false;
    }
    const body = JSON.stringify({
        token,
        client_id: clientId,
    });
    const response = yield (0, fetch_1.post)(`${RSI_API_HOST}/v1/aut/oauth/provider/introspect`, {
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        body,
    }, callback);
    return response === null ? false : response.active;
});
exports.introspectToken = introspectToken;
